import { render, staticRenderFns } from "./InformativaRegistrazioneStruttura.vue?vue&type=template&id=0f4c949b&scoped=true&"
import script from "./InformativaRegistrazioneStruttura.vue?vue&type=script&lang=js&"
export * from "./InformativaRegistrazioneStruttura.vue?vue&type=script&lang=js&"
import style0 from "./InformativaRegistrazioneStruttura.vue?vue&type=style&index=0&id=0f4c949b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c949b",
  null
  
)

export default component.exports